<app-loader [loadingState]="loadingState$ | async" relativeWidthAndHeight="true" [top]="72"></app-loader>

<div class="min-h-full flex flex-col">
  <app-header
    [title]="
      (session$ | async)?.groups[0]?.groups_agreement?.external_id
        ? 'Resend Agreement for Signatures'
        : 'Send Agreement for Signatures'
    "
  >
    <button
      additional-slot
      id="close-modal-button"
      class="btn-primary m-0 flex items-center justify-center w-min p-1"
      (click)="closeModal()"
    >
      <ion-icon class="h-5 w-5" name="close-outline"></ion-icon>
    </button>
  </app-header>

  <div class="flex-grow p-4 overflow-y-auto">
    <span class="text-sm">
      @if (!(session$ | async)?.groups[0]?.groups_agreement?.external_id) {
        <span class="font-semibold"> Please provide the email address of the person who will sign the agreement </span>
      } @else {
        <span class="font-semibold">
          The agreement was sent for signatures. If you want to resend it, please provide the email address of the
          person who will sign the agreement.
        </span>
      }
    </span>

    <form [formGroup]="sendAgreementForSignaturesForm" class="pt-2">
      <div class="form-input">
        <label class="text-xs font-normal">Signatory Email</label>
        <input
          id="signatory-email"
          clear-input="true"
          formControlName="email"
          type="email"
          [ngClass]="{
            'border-bright-crimson text-bright-crimson focus:ring-1 ring-bright-crimson':
              sendAgreementForSignaturesForm.controls['email'].errors &&
              sendAgreementForSignaturesForm.controls['email'].touched,
          }"
        />
        @if (
          sendAgreementForSignaturesForm.controls['email'].errors &&
          sendAgreementForSignaturesForm.controls['email'].touched
        ) {
          <div class="text-bright-crimson py-2 text-xs absolute right-0 -mt-2" id="signatory-email-errors">
            @if (sendAgreementForSignaturesForm.controls['email'].errors?.['required']) {
              <div id="required" class="error">Email is required</div>
            }
            @if (sendAgreementForSignaturesForm.controls['email'].errors?.['pattern']) {
              <div id="invalid" class="error">This isn't a valid email address</div>
            }
          </div>
        }
      </div>
      <div class="form-input">
        <ion-checkbox
          id="confirm-signatory-email"
          label-placement="end"
          class="-mt-0.5 text-xs p-0 block w-full"
          formControlName="confirmSignatoryEmail"
        >
          <span class="block whitespace-normal break-words">
            I confirm that the email address provided belongs to the person who will sign the agreement, and that this
            person is authorized to sign agreements on behalf of their organization.
          </span>
        </ion-checkbox>
      </div>
    </form>
  </div>

  <footer class="flex gap-2 p-3 w-full border-t-2 border-grey-concrete justify-between">
    <button
      id="send-agreement-for-signatures-button"
      class="btn-primary text-sm"
      [disabled]="sendAgreementForSignaturesForm.invalid"
      (click)="sendAgreementForSignatures()"
    >
      {{ (session$ | async)?.groups[0]?.groups_agreement?.external_id ? 'Resend' : 'Send' }} Agreement
    </button>
    <button id="cancel-send-agreement-for-signatures" class="btn-default text-sm" (click)="closeModal()">Cancel</button>
  </footer>
</div>
